<template>
  <section class="bill-wrapper">
    <div class="order_list">
      <van-list offset="400" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <van-checkbox-group v-model="chooseResult" @change="onChooseChange" ref="checkboxGroup">
          <van-cell-group v-for="(item, index) in orders" :key="index" @click.stop="onSingleChoose(item, index)"
            class="order_list__group">
            <!-- 停车场、复选框 -->
            <van-cell :title="item.parkName">
              <van-checkbox :disabled="(sameArea==0)?false:sameArea!=item.remark1" icon-size="14px" :name="item"
                @click.stop="onSingleChoose(item, index)" ref="checkBoxes" slot="right-icon" />
            </van-cell>
            <!-- 基础信息 -->
            <van-cell :title="item.cardNumber" :label="item.orderPayTime">
              <div slot="default" class="order_list__group__price">
                ¥ {{ item.paidMoney/100 }}
                <br>
                <van-button @click.stop="jump(item)" plain type="info" size="mini">问题反馈</van-button>
              </div>
            </van-cell>

          </van-cell-group>
        </van-checkbox-group>
      </van-list>
    </div>
    <div class="order_handler">
      <van-submit-bar safe-area-inset-bottom :price="totalPrice" button-text="确认开票" button-type="info"
        @submit="onSubmit">
        <van-checkbox :disabled="this.chooseResult.length==0" v-model="checked">同类全选</van-checkbox>
        <span class="order_handler__tip" slot="tip">
          已选
          <span class="order_handler__tip__num">{{ chooseResult.length }}</span>
          条订单
        </span>
      </van-submit-bar>
    </div>
  </section>
</template>

<script>
import { List, CellGroup, Checkbox, CheckboxGroup, SubmitBar } from 'vant'
import { selectWxPaidrecordList } from '@/api/park'
import { SetIssuer } from '@/api/invoice'
export default {
  props: {
    orders: {
      type: Array,
      default () {
        return {}
      }
    },
    params: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    [List.name]: List,
    [CellGroup.name]: CellGroup,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [SubmitBar.name]: SubmitBar
  },
  watch: {
    orders: {
      handler (newVal, oldVal) {
        if (newVal == oldVal) {
          return
        }
        this.chooseResult = []
      },
      deep: true
    },
    // 全选反选切换
    checked (val) {
      if (val) {
        for (let i = 0; i < this.orders.length; i++) {
          if (this.sameArea == this.orders[i].remark1) {
            this.$refs.checkBoxes[i].toggle(true)
          }
        }
      } else {
        this.$refs.checkboxGroup.toggleAll(false)
        this.sameArea = 0
      }
    },
    // 监听是否有选择
    chooseResult (val) {
      console.log(val)
      if (val.length === 0) {
        this.sameArea = 0
        this.checked = false
      }
    }
  },
  data () {
    return {
      sameArea: 0,
      totalPrice: 0,
      chooseResult: [], //选择项
      loading: false, //加载中。。。
      finished: false, //结束所有状态
      checked: false
    }
  },
  mounted () {
  },
  methods: {
    jump (item) {
      this.$store.dispatch('invoice/SetPendingBill', item)
      this.$router.push({ name: 'Feedback' })
    },
    onLoad () {

      let _this = this;

      _this.params.startPage++
      selectWxPaidrecordList(_this.params).then(res => {
        let data = res.body.list
        data.forEach(element => {
          if (element.billingStatus == 0) {
            _this.orders.push(element)
          }
        });
        _this.finished = false
        _this.loading = false;
        if (_this.orders.length >= res.body.totalRows) {
          _this.finished = true
          _this.loading = true;
        }
      }).catch(err => {
        _this.$notify({
          type: 'danger',
          message: err
        })
      })
    },
    // 单选
    onSingleChoose (item, index) {
      // When toggle method is called multiple times at the same time,
      // only the last call is valid.
      // This is a hack for usage inside Cell.
      //源码中该方法是异步的，所以后续打印不会立即展示结果
      if (!item.remark1) {
        this.$notify({
          type: 'danger',
          message: '该路段无法开票，如需开票请拨打小票上的监督电话，进行人工开票。'
        })
      }
      if (this.sameArea == 0 && item.remark1) {
        this.sameArea = item.remark1
      }
      if (this.sameArea == item.remark1) {
        this.$refs.checkBoxes[index].toggle()
      }
    },
    onChooseChange (val) {
      console.log(val)
      this.totalPrice = val.reduce(function (prev, cur) {
        return Number(cur.paidMoney) + prev
      }, 0)
    },
    //确认开票
    onSubmit () {
      let _this = this
      if (_this.chooseResult.length === 0) {
        _this.$toast.fail('请选择订单');
        return
      }
      for (let item of _this.chooseResult) {
        if (!item.remark1) {
          this.$notify({
            type: 'danger',
            message: '该路段无法开票，如需开票请拨打小票上的监督电话，进行人工开票。'
          })
          return
        }
      }
      SetIssuer({ parkId: Number(_this.chooseResult[0].parkId) }).then(res => {
        if (!res.body) {
          _this.$toast.fail('暂无销售方信息');
          return
        }
        if (res.body.invoiceMerchant == 1) {
          let params = {
            openid: res.body.openid,
            appsecret: res.body.appSecret,
          }
          this.$store.dispatch('invoice/GetToken', params)
        }
        _this.$router.push({ name: 'Invoice-Form' })
        _this.$store.dispatch('invoice/SetInvoiceInfo', res.body)
        _this.$store.dispatch('invoice/SetPendingBill', _this.chooseResult)
      })
        .catch(err => {
          _this.$notify({
            type: 'danger',
            message: err
          })
        })
    }
  }
}
</script>


<style lang="scss" scoped>
.bill-wrapper {
  height: 100vh;
  background-color: #f5f5f5;

  .order_list {
    overflow-y: scroll;
    padding: 0 8px 0;
    height: calc(100vh - 84px - 1px);

    &__group {
      margin: 5px 0 5px;

      &__price {
        color: #4b62ec;
        font-weight: 500;
        font-size: 12px;

        &__integer {
          display: inline-block;
          font-size: 20px;
          font-family: Avenir-Heavy, PingFang SC, Helvetica Neue, Arial,
            sans-serif;
        }
      }
    }
  }

  .order_handler {
    /deep/ .van-submit-bar__tip,
    &__tip {
      color: #444444;
      background-color: #ffffff;
      border-bottom: 1px solid #f5f5f5;

      &__num {
        color: #f56723;
      }
    }
  }
}
</style>